import React from 'react';

import { useNotificationStream } from '../../hooks/stream/useNotificationStream';

export const NotificationStream: React.FC = () => {
  useNotificationStream();
  return null;
};
